import styled from 'styled-components';
import GoIconSVG from './go-icon.svg';

const GoIcon = styled(GoIconSVG as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || '#647a97'};
  margin: ${props => props.margin || ''};
`;

export default GoIcon;

